import { AccountType, type IProfileResponse } from '../api/types';

export function isProfileStudent(user: IProfileResponse | null | undefined): boolean {
  return user?.accountType === AccountType.Student;
}

export function isProfileStaff(user: IProfileResponse | null | undefined): boolean {
  return user?.accountType === AccountType.Staff;
}
